import toast from 'react-hot-toast';
import { CheckCircle2, XCircle, SkipForward } from 'lucide-react';
import { useMatchingStore } from '../../store/matchingStore';

interface ActionButtonsProps {
  rowId: string;
}

export const ActionButtons = ({ rowId }: ActionButtonsProps) => {
  const confirmDistinct = useMatchingStore((s) => s.confirmDistinct);
  const confirmDuplicate = useMatchingStore((s) => s.confirmDuplicate);
  const skip = useMatchingStore((s) => s.skip);
  const inFlight = useMatchingStore((s) => s.actionInFlight.has(rowId));

  const handleDistinct = async () => {
    try {
      await confirmDistinct(rowId);
      toast.success('Created Lead Org');
    } catch (err) {
      const e = err as { response?: { data?: { message?: string } } };
      toast.error(e.response?.data?.message ?? 'Failed to confirm distinct');
    }
  };

  const handleDuplicate = async () => {
    try {
      await confirmDuplicate(rowId);
      toast.success('Marked as duplicate');
    } catch (err) {
      const e = err as { response?: { data?: { message?: string } } };
      toast.error(e.response?.data?.message ?? 'Failed to confirm duplicate');
    }
  };

  return (
    <div className="flex items-center gap-2 mt-4">
      <button
        type="button"
        onClick={handleDistinct}
        disabled={inFlight}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md bg-green-600 text-white hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <CheckCircle2 className="h-4 w-4" />
        Confirm Distinct
      </button>
      <button
        type="button"
        onClick={handleDuplicate}
        disabled={inFlight}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <XCircle className="h-4 w-4" />
        Confirm Duplicate
      </button>
      <button
        type="button"
        onClick={() => skip(rowId)}
        disabled={inFlight}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <SkipForward className="h-4 w-4" />
        Skip for now
      </button>
    </div>
  );
};
